<template>
    <div>
        <vue-glide
                :autoplay="3000"
                :per-view="1"
                :hoverpause="false"
                v-if="sliders.length>0">
            <vue-glide-slide :key="s.id" v-for="s in sliders" >
                <v-img :src="s.image" style="height: 100vh; margin-left:-12px;"></v-img>
            </vue-glide-slide>
        </vue-glide>
    </div>
</template>

<script>
    import Http from "axios";
    import {API_URL, VERSION} from "../config/config";

    import { Glide, GlideSlide } from 'vue-glide-js'

    export default {
        name: "Slider",
        components: {

            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        props:['type'],
        data(){
          return {
              sliders:[]
          }
        },
        mounted() {
            Http.get(`${API_URL}${VERSION}/sliders/list-all?type=${this.type}`).then(response => {
                this.sliders = response.data.data;
            });
        }
    }
</script>

<style scoped>

</style>
